import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { TableActions } from '@ami/react/core';
import { OrderDocumentsTable as Table } from '@ami/react/shared';
import { OrderDocumentsFilterComponent as FilterComponent } from '@ami/react/shared';
import { documentsLookupService } from '@ami/react/shared';
import { DocumentsLookupFilter } from '@ami/react/shared';
import { pagination } from '@ami/react/core';
import { Alert } from 'reactstrap';

class OrderDocumentsListPage extends Component {
  constructor() {
    super();
    this.search = this.search.bind(this);
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    title: PropTypes.string,
  };

  state = {
    items: [],
    filter: new DocumentsLookupFilter(),
    loading: false,
    downloadingId: null,
    partNumberPrefix: null,
    serialNumber: null,
    searched: false,
  };

  search() {
    if (!this.state.loading) {
      this.setState({ loading: true, searched: false });
    }

    documentsLookupService
      .search(this.state.filter, 0, true)
      .then((items) => this.setState({ items, searched: true }))
      .finally(() => this.setState({ loading: false }));

    const { partNumberPrefix, serialNumber } = this.state.filter;
    this.setState({ partNumberPrefix, serialNumber });
  }

  handleOnDownload = (orderId, documentId, downloadingId, isLegacy) => {
    this.setState({ downloadingId });
    const { partNumberPrefix, serialNumber } = this.state;
    const filter = new DocumentsLookupFilter({
      orderId,
      documentId,
      partNumberPrefix,
      serialNumber,
    });
    const downloadFunction = isLegacy
      ? documentsLookupService.getLegacyDocumentDownloadUrl
      : documentsLookupService.getDocumentDownloadUrl;
    downloadFunction(filter, true)
      .then((response) => (window.location = response.url))
      .finally(() => this.setState({ downloadingId: null }));
  };

  render() {
    return (
      <div>
        <div className="flextable">
          <h3 className="flextable-item flextable-primary page-title">
            {this.props.title}
          </h3>
        </div>
        <TableActions>
          <FilterComponent
            filter={this.state.filter}
            onChange={(x) =>
              this.setState({ filter: new DocumentsLookupFilter(x) })
            }
            onFilter={() => this.search()}
          />
        </TableActions>
        <Table
          documents={this.state.items}
          onDownload={this.handleOnDownload}
          loading={this.state.loading}
          downloadingId={this.state.downloadingId}
          searched={this.state.searched}
        />
        {this.state.items.length === pagination.pageSize && (
          <Alert className="mt-4 mb-3" color="primary">
            Too many results returned, please change your search criteria and
            try again
          </Alert>
        )}
      </div>
    );
  }
}

export default withRouter(OrderDocumentsListPage);
